import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import ReportsRepository from "src/repository/Admin/ReportRepository";
import { getForbiddenResponseMessage } from "src/service/forbiddenResponseMessage";

export const getReportsList = createAsyncThunk('get_reports_list', async (params) => {
    try {
        const data = await new ReportsRepository().getReportsList(params);
        return data;
    } catch (error) {
        return { data: { getListOfAccountAndUserReport: [], total: 0 }, message: getForbiddenResponseMessage(error) }
    }
});

const slice = createSlice({
    name: "Reports",
    initialState: {
        totalRecords: 0,
        filteredRecords: 0,
        reportsListMessage: '',
        reportsList: [],
    },
    reducers: {
        setReportsList: {
            reducer: (state, action) => {
                state.reportsList = action.payload;
                state.reportsListMessage = '';
                return state;
            },
        },
        setReportsListMessage: {
            reducer: (state, action) => {
                state.reportsListMessage = action.payload;
                return state;
            },
        },
    },
    extraReducers: {
        [getReportsList.fulfilled]: (state, action) => {
            state.reportsList = action.payload.data?.getListOfAccountAndUserReport;
            state.totalRecords = action.payload.data?.total;
            state.filteredRecords = action.payload.data?.getListOfAccountAndUserReport?.length;
            state.reportsListMessage = action.payload.message || '';
        },
    },
});



export let { setReportsList, setReportsListMessage } = slice.actions;

export default slice.reducer;
